import type { JSX } from 'react';

type TSeoConfig = {
  title: string;
  description: string;
  keywords?: string;
};

type THeadMeta = { meta: Array<JSX.IntrinsicElements['meta']> };

export const buildRouteMeta = (config: TSeoConfig): THeadMeta => {
  const meta: Array<JSX.IntrinsicElements['meta']> = [
    { title: config.title } as JSX.IntrinsicElements['meta'],
    { name: 'description', content: config.description },
  ];

  if (config.keywords) {
    meta.push({ name: 'keywords', content: config.keywords });
  }

  return { meta };
};
